<script setup lang="ts">
import OneButton from '@/common/components/molecules/button/OneButton.vue';
import TagItem from '@/common/components/molecules/tag/TagItem.vue';
import MenuSearchResultItem from '@/common/components/organisms/menuSearch/menuSearchContent/menuSearchResult/MenuSearchResultItem.vue';

import { setup } from './menuSearchFavoriteDashboard.setup';

const { favoriteDashboardList, getDashboardType, handleClick, handleClickFavorite } = setup();
</script>

<template>
  <ul class="menu-search-favorite-dashboard">
    <menu-search-result-item
      v-for="item in favoriteDashboardList"
      :id="item.id"
      :key="item.id"
      :icon="item.icon"
      :title="item.title"
      :path="item.path"
      :featured-icon="item.featuredIcon"
      @on-click="() => handleClick(item)"
    >
      <template #subTitle>
        <tag-item
          html-type="span"
          size="small"
          :class="`dashboard-sub-title dashboard-sub-title--${item.dashboardType}`"
          >{{ getDashboardType(item.dashboardType) }}</tag-item
        >
      </template>
      <template #suffix>
        <one-button
          size="small"
          type="icon"
          class="menu-search-result-item__suffix"
          @click.stop="
            handleClickFavorite({
              dashboardId: item.dashboardId,
              favoriteId: item.favoriteId,
              dashboardType: item.dashboardType,
            })
          "
        >
          <ev-icon icon="icon-fill-star" />
        </one-button>
      </template>
    </menu-search-result-item>
  </ul>
</template>
